export default __webpack_public_path__ + "static/media/TutorialFinalProduct.fb374728.png";